import { defineComponent as _defineComponent } from 'vue';
import { defineComponent } from 'vue';
import AuthorizedHeader from './AuthorizedHeader.vue';
import UnauthorizedHeader from './UnauthorizedHeader.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    authorized: {
      type: Boolean,
      required: true
    }
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'AppHeader'
    });
    return {
      __sfc: true,
      AuthorizedHeader: AuthorizedHeader,
      UnauthorizedHeader: UnauthorizedHeader
    };
  }
});